import { render, staticRenderFns } from "./SystemForm.vue?vue&type=template&id=4ca1d4f4&scoped=true&"
import script from "./SystemForm.vue?vue&type=script&lang=js&"
export * from "./SystemForm.vue?vue&type=script&lang=js&"
import style0 from "./SystemForm.vue?vue&type=style&index=0&id=4ca1d4f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca1d4f4",
  null
  
)

export default component.exports